export type RequestInterceptor = (options: RequestInit) => Promise<RequestInit>;
export type ResponseInterceptor = (response: Response) => Promise<Response>;

export const httpInterceptors = {
  requestInterceptors: [] as RequestInterceptor[],
  responseInterceptors: [] as ResponseInterceptor[],
  responseRegister(interceptor: ResponseInterceptor) {
    httpInterceptors.responseInterceptors.push(interceptor);
  },
  requestRegister(interceptor: RequestInterceptor) {
    httpInterceptors.requestInterceptors.push(interceptor);
  },
};
